"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.System = void 0;
const constants_1 = require("../../constants");
const ModelCommon_1 = require("../../model/ModelCommon");
class System extends ModelCommon_1.ModelCommon {
    constructor(ob) {
        super(constants_1.SYSTEM.type, { ...ob, ...constants_1.SYSTEM });
    }
}
exports.System = System;
